import { render, staticRenderFns } from "./BuildingSearch.vue?vue&type=template&id=1bf76ac6&scoped=true"
import script from "./BuildingSearch.vue?vue&type=script&lang=js"
export * from "./BuildingSearch.vue?vue&type=script&lang=js"
import style0 from "./BuildingSearch.vue?vue&type=style&index=0&id=1bf76ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf76ac6",
  null
  
)

export default component.exports